<script>
  import { UsersRepository, GroupsRepository, RolesRepository } from "../repositories/index"
  import { CustomAutocomplete } from "./index"
  import { validators } from "../utils"
  import { user } from "../stores/index"

  import { Button, Form, TextField, Submit, Flex, FlexItem, Autocomplete, Checkbox, Modal } from "@gl/design-system"
  import { _ } from "../stores/index"

  import { createEventDispatcher, onMount } from "svelte"
  const dispatch = createEventDispatcher()

  export let groups
  export let roles
  export let modalType
  export let data
  export let active

  const loading = {}

  const form = {
    groups: [],
    roles: [],
  }

  let autocompleteGroups
  let autocompleteRoles

  async function onSubmit() {
    loading.submit = true

    let requestBody = {
      firstName: form.firstName,
      lastName: form.lastName,
      isMaster: form.master,
    }

    if (modalType === "post") requestBody.email = form.email

    let user
    try {
      user =
        modalType === "put"
          ? await UsersRepository.editUser(data.id, requestBody)
          : await UsersRepository.addUser(requestBody)
    } finally {
      if (user) {
        //add groups to user
        if (form.groups && modalType === "post") {
          await Promise.all(
            form.groups.map((g) =>
              GroupsRepository.addGroupUser(g.value, {
                users: [user.id],
              })
            )
          )
        }
        if (form.roles && modalType === "post") {
          await Promise.all(
            form.roles.map((g) =>
              RolesRepository.addRoleUser(g.value, {
                users: [user.id],
              })
            )
          )
        }
        dispatch("success", { userId: user.userId })
        dispatch("close")
      }
      loading.submit = false
    }
  }

  onMount(() => {
    if (modalType === "put") {
      form.firstName = data.firstName
      form.lastName = data.lastName
      form.email = data.email
      form.master = data.isMaster
    } else {
      autocompleteGroups =
        groups.length &&
        groups.map((group) => (group = { label: group.name, value: group.id, disabled: !!group.missingPolicies }))
      autocompleteRoles =
        roles.length &&
        roles.map((role) => (role = { label: role.name, value: role.id, disabled: !!role.missingPolicies }))
    }
  })
</script>

<Modal bind:active on:close boxed>
  <div class="gl-title mb-4">
    {modalType === "put" ? $_("users.edit_user") : $_("users.add_user")}
  </div>

  <Form validationMode="eager">
    <TextField
      bind:value={form.email}
      id="user-email"
      label={$_("users.email_address")}
      variant="Email"
      required={$_("validations.required")}
      validate={(value) => validators.isEmail(value)}
      disabled={modalType === "put"}
    />

    <TextField
      bind:value={form.firstName}
      id="user-firstName"
      label={$_("users.firstName")}
      required={$_("validations.required")}
      validate={(value) => validators.isValidNameWithSpaces(value)}
      maxLength={50}
      config={{ characterCount: $_("character.count") }}
    />

    <TextField
      bind:value={form.lastName}
      id="user-lastName"
      label={$_("users.lastName")}
      required={$_("validations.required")}
      validate={(value) => validators.isValidNameWithSpaces(value)}
      maxLength={50}
      config={{ characterCount: $_("character.count") }}
    />

    {#if autocompleteGroups && modalType === "post"}
      <div class="mb-5">
        <p class="mb-2">{$_("common.groups")}</p>
        <CustomAutocomplete options={autocompleteGroups} bind:value={form.groups} />
      </div>
    {/if}

    {#if autocompleteRoles && modalType === "post"}
      <div class="mb-5">
        <p class="mb-2">{$_("common.roles")}</p>
        <CustomAutocomplete options={autocompleteRoles} bind:value={form.roles} />
      </div>
    {/if}

    {#if $user.data.isMaster}
      <Checkbox bind:value={form.master} label="Master user" />
    {/if}

    {#if modalType === "put"}
      <p class="color-grey-dark mb-5" style="font-size:14px">
        {$_("users.edit.warning")}
      </p>
    {/if}

    <Flex>
      <FlexItem>
        <Submit loading={loading.submit} on:submit={onSubmit} label={$_("buttons.save")} />
      </FlexItem>
      <FlexItem class="ml-4">
        <Button outlined on:click={() => dispatch("close")}>{$_("buttons.cancel")}</Button>
      </FlexItem>
    </Flex>
  </Form>
</Modal>
